export const getCurrentLang = () => {
  return localStorage.getItem('lang') ?? 'fr';
};
